import { useFilteredDestinationNodes } from './hooks'
import { Table } from 'shared/ui/Table/Table'
import React from 'react'
import { activityNodeMapAtom, destTreeIdMap } from './atoms'
import { useAtomValue } from 'infrastructure/state/jotai.wrapper'
import {
  getNodeRowDataAsString,
  nodePathCell,
  openKiddomCell,
  titleCell,
} from './tableColumns'

export function DestinationTree() {
  const filteredNodes = useFilteredDestinationNodes()
  const columns = useTreeColumns()
  return (
    <Table
      title={`Destination Tree Activity Nodes ${filteredNodes.length}`}
      columns={columns}
      items={filteredNodes}
      canExport={true}
    />
  )
}

function useTreeColumns() {
  const idMap = useAtomValue(destTreeIdMap)
  const activityMap = useAtomValue(activityNodeMapAtom)
  return [
    {
      title: 'Title',
      rowContent: titleCell(idMap),
      rowString: getNodeRowDataAsString({
        destIdMap: idMap,
        nodeMapping: activityMap,
        dataType: 'title',
      }),
    },
    {
      title: 'Node Path',
      rowContent: nodePathCell(idMap),
      rowString: getNodeRowDataAsString({
        destIdMap: idMap,
        nodeMapping: activityMap,
        dataType: 'path',
      }),
    },
    {
      title: 'Mapped',
      rowContent(nodeId: string) {
        const node = activityMap[nodeId]
        if (node?.length !== 1) return 'UnMapped'
        return node[0].title
      },
      rowString: (nodeId: string) => {
        const node = activityMap[nodeId]
        if (node?.length !== 1) return 'UnMapped'
        return node[0].title
      },
    },
    {
      title: 'Kiddom',
      rowContent: openKiddomCell(idMap),
      rowString: getNodeRowDataAsString({
        destIdMap: idMap,
        nodeMapping: activityMap,
        dataType: 'url',
      }),
    },
  ]
}
